import { post } from "@/utils/utils";
// 导购相关接口
const guider = {
  state: {
    wakeUpMember: {
      records: [],
      total: 0
    },
    allWakeUpMemberList: [],
    guiderReward: {
      records: [],
      total: 0
    },
    allGuiderRewardList: [],
    guiderOrderDetails: {
      records: [],
      total: 0
    },
    allGuiderOrderDetailsList: [],
    wakeUpConfig: {}
  },
  mutations: {
    QUERY_WAKE_UP_MEMBER_LIST(state, data) {
      state.wakeUpMember = data.result;
    },
    QUERY_ALL_WAKE_UP_MEMBER_LIST(state, data) {
      state.allWakeUpMemberList = data.result.records || [];
    },
    QUERY_GUIDER_REWARD_LIST(state, data) {
      state.guiderReward = data.result;
    },
    QUERY_ALL_GUIDER_REWARD_LIST(state, data) {
      state.allGuiderRewardList = data.result.records || [];
    },
    QUERY_GUIDER_REWARD_DETAILS(state, data) {
      state.guiderOrderDetails = data.result;
      if (state.guiderOrderDetails.records.length) {
        state.guiderOrderDetails.records.forEach(v => {
          v.eventFormat = v.event === "firstWake" ? "唤醒积分" : "购物积分";
        });
      }
    },
    QUERY_ALL_GUIDER_REWARD_DETAILS(state, data) {
      state.allGuiderOrderDetailsList = data.result.records || [];
      if (state.allGuiderOrderDetailsList.length) {
        state.allGuiderOrderDetailsList.forEach(v => {
          v.eventFormat = v.event === "firstWake" ? "唤醒积分" : "购物积分";
        });
      }
    },
    EDIT_WAKE_UP_CONFIG(state, data) {
      state.editWakeUpCode = data.code;
    },
    SHOW_WAKE_UP_CONFIG(state, data) {
      state.wakeUpConfig = data.result;
    }
  },
  actions: {
    queryWakeUpMemberList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/wake_member_list`,
        name: "QUERY_WAKE_UP_MEMBER_LIST",
        params
      });
    },
    queryAllWakeUpMemberList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/wake_member_list`,
        name: "QUERY_ALL_WAKE_UP_MEMBER_LIST",
        params
      });
    },
    queryGuiderRewardList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/wake_reward_list`,
        name: "QUERY_GUIDER_REWARD_LIST",
        params
      });
    },
    queryAllGuiderRewardList({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/wake_reward_list`,
        name: "QUERY_ALL_GUIDER_REWARD_LIST",
        params
      });
    },
    queryGuiderRewardDetials({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/wake_reward_detail`,
        name: "QUERY_GUIDER_REWARD_DETAILS",
        params
      });
    },
    queryAllGuiderRewardDetials({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/wake_reward_detail`,
        name: "QUERY_ALL_GUIDER_REWARD_DETAILS",
        params
      });
    },
    editWakeUpConfig({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/edit_wake_config`,
        name: "EDIT_WAKE_UP_CONFIG",
        params
      });
    },
    showWakeUpConfig({ commit }, params) {
      return post({
        commit,
        url: `/promotion/activity/show_wake_config`,
        name: "SHOW_WAKE_UP_CONFIG",
        params
      });
    }
  }
};

export default guider;
